import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAHfhaq-xHzRBXu4MiMbSvlYLRF_IuBNPo",
  authDomain: "rolam-co.firebaseapp.com",
  projectId: "rolam-co",
  storageBucket: "rolam-co.appspot.com",
  messagingSenderId: "35925011344",
  appId: "1:35925011344:web:8422270ea8727e67d6e115",
  measurementId: "G-SGDN2M4K45"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);